import { ApiError } from "@/lib/api";
import { useTranslation } from "react-i18next";
import { useHolyModeOptional } from "@/preferences/holy-mode";
import { SacredIcon } from "./sacred-icon";

export function Loading() {
  const { t } = useTranslation();
  const { enabled } = useHolyModeOptional();
  return <p className={`query-loading text-muted py-10 text-center text-sm${enabled ? " query-loading--holy" : ""}`} role={enabled ? "status" : undefined}>
    {enabled ? <><SacredIcon name="seal" size={24} /><span>{t("holy.loadingCaption")}</span></> : t("common.loading")}
  </p>;
}

/** 403 shows "sem permissão"; anything else shows a plain error. Never a blank page. */
export function ErrorState({ error }: { error: unknown }) {
  const { t } = useTranslation();
  const { enabled } = useHolyModeOptional();
  if (error instanceof ApiError && error.forbidden) {
    return (
      <div role="alert" className={`query-error border-border bg-surface rounded-xl border p-8 text-center${enabled ? " query-error--holy" : ""}`}>
        {enabled ? <SacredIcon name="keys" size={30} /> : null}
        <h2 className="text-foreground text-base font-semibold">{t("errors.noAccessTitle")}</h2>
        <p className="text-muted mt-1 text-sm">{t("errors.noAccessBody")}</p>
      </div>
    );
  }
  return (
    <div role="alert" className={`query-error border-danger/40 bg-danger-soft rounded-xl border p-6 text-center${enabled ? " query-error--holy" : ""}`}>
      {enabled ? <SacredIcon name="cross" size={26} /> : null}
      <h2 className="text-foreground text-base font-semibold">{t("errors.loadTitle")}</h2>
      <p className="text-secondary mt-1 text-sm">{error instanceof ApiError ? error.message : t("errors.tryAgain")}</p>
    </div>
  );
}
